import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useAppContext } from '../AppContext';

const Cart = ({ cartItems, onProceedToCheckout, onCancel, onDeleteItem }) => {
  const { t } = useAppContext();
  // Group items by name and calculate total quantity and price for each group
 
  const groupedItems = cartItems.reduce((acc, item) => {
    const existingItem = acc.find((i) => i.name === item.name && i.selectedVariant === item.selectedVariant);
    if (existingItem) {
      existingItem.quantity += item.quantity;
      existingItem.totalPrice += (item.price + item.variantPrice) * item.quantity;
    } else {
      acc.push({
        ...item,
        totalPrice: (item.price + item.variantPrice) * item.quantity
      });
    }
    return acc;
  }, []);


  // Calculate the total price of all items in the cart
  const totalCartPrice = groupedItems.reduce((total, item) => total + item.totalPrice, 0);

  const formatToMyanmarCurrency = (number) => {
    const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
    return `${formattedNumber} MMK`;
  };

  return (
    <Box sx={{ marginTop: 2 }}>
      <Typography variant="h6" gutterBottom>
        {t("Selected Items")}
      </Typography>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("Name")}</TableCell>
              <TableCell align="right">{t("Qty")}</TableCell>
              <TableCell align="left">{t("Variant")}</TableCell>
              <TableCell align="right">{t("Price")}</TableCell>
              <TableCell align="right">{t("Amount")}</TableCell>
              <TableCell align="right">{t("Action")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groupedItems.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.name}</TableCell>
                <TableCell align="right">{item.quantity}</TableCell>
                <TableCell align="left"><strong>{item.selectedVariant}</strong></TableCell>
                <TableCell align="right">{formatToMyanmarCurrency(item.price + item.variantPrice)}</TableCell>
                <TableCell align="right">{formatToMyanmarCurrency(item.totalPrice)}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => onDeleteItem(item.name, item.selectedVariant)}>
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={4} align="right"><strong>{t("Total")}</strong></TableCell>
              <TableCell align="right"><strong>{formatToMyanmarCurrency(totalCartPrice)}</strong></TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {groupedItems.length > 0 && (
        <Box sx={{ marginTop: 2, marginBottom:5 }}>
          <Button variant="contained" color="primary" onClick={onProceedToCheckout} disableElevation>
            {t("Accept Order")}
          </Button>
          <Button variant="outlined" color="secondary" onClick={onCancel} sx={{ marginLeft: 1 }} disableElevation>
            {t("Cancel")}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Cart;
